<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Vouchers Cancelados/Rejeitados
            <Modal
              :tipoSelecao="'single'"
              :dataDisable="true"
              @unidade="getVouchersCanceladosRejeitados"
              :loadingValue="loadingValue"
            >
              <template v-slot:conteudo>
                <div class="row q-mt-sm text-brand-5 text-weight-bold">
                  <span style="width: 48%" class="col-2 q-ml-sm q-mt-sm"
                    >Data Inicial</span
                  >
                  <span style="width: 44%" class="col-2 q-ml-sm q-mt-sm"
                    >Data Final</span
                  >
                </div>
                <div class="row col col-3 q-px-sm">
                  <q-input
                    style="width: 49%"
                    class="col input"
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="datas.from"
                    mask="##/##/####"
                    :rules="[
                      (val) => validarDataEmissao(val) || 'Data Invalida',
                    ]"
                  >
                    <template v-slot:append>
                      <q-icon name="event" class="cursor-pointer">
                        <q-popup-proxy
                          cover
                          transition-show="scale"
                          transition-hide="scale"
                        >
                          <q-date
                            :locale="myLocale"
                            :options="optionsFn"
                            mask="DD/MM/YYYY"
                            v-model="datas"
                            range
                          >
                            <div class="row items-center justify-end">
                              <q-btn
                                v-close-popup
                                label="Fechar"
                                color="primary"
                                flat
                              />
                            </div>
                          </q-date>
                        </q-popup-proxy>
                      </q-icon>
                    </template>
                  </q-input>
                  <q-input
                    class="col q-ml-sm input"
                    style="width: 49%"
                    dense
                    outlined
                    placeholder="DD/MM/AAAA"
                    v-model="datas.to"
                    mask="##/##/####"
                    :rules="[
                      (val) => validarDataEmissao(val) || 'Data Invalida',
                    ]"
                  />
                </div>
                <div class="row q-px-sm text-brand-5 text-weight-bold">
                  <div class="col">
                    <div class="texto-titulo-input">Status</div>
                    <q-select
                      dense
                      outlined
                      multiple
                      v-model="statusSelecionado"
                      :options="statusOptions"
                      option-value="value"
                      option-label="label"
                      emit-value
                      map-options
                      placeholder="Selecione o(s) status"
                    />
                  </div>
                </div>
              </template>
            </Modal>
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Vouchers_Cancelados_Rejeitados'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'vouchers-cancelados-rejeitados'"
      @enviarRespostaEp="getRelatorioSalvo"
      @flexmonsterLoading="loadingStop"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { transformCsvAndSetLink } from "../../../utils/csvHelper.js";
import { validarDataEmissao } from "../../../helpers/dateValidation";

import Modal from "../components/Modal.vue";
import Flexmonster from "../components/Flexmonster.vue";

export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: "",
      rows: [{ uniqueName: "Unidade_Nome" }],
      reportFilters: "",
      measures: [
        { uniqueName: "Requisicao_Numero" },
        { uniqueName: "Nome_Requisitante" },
        { uniqueName: "Nome_Solicitante" },
        { uniqueName: "Matricula_Solicitante" },
        { uniqueName: "Codigo_Centro_Custo" },
        { uniqueName: "Nome_Centro_Custo" },
        { uniqueName: "Conta_Centro_Custo" },
        { uniqueName: "Codigo_Produto" },
        { uniqueName: "Descricao_Produto" },
        { uniqueName: "Nome_Grupo" },
        { uniqueName: "Ca" },
        { uniqueName: "Categoria" },
        { uniqueName: "Preco_Produto", format: "numberFormat" },
        { uniqueName: "Quantidade", format: "numberFormat" },
        { uniqueName: "Descricao_Observacoes" },
        { uniqueName: "Data_Solicitacao" },
        { uniqueName: "Total", format: "numberFormat" },
        { uniqueName: "Status" },
        { uniqueName: "Nome_Usuario_Cancelamento" },
        { uniqueName: "Matricula_Usuario_Cancelamento" },
        { uniqueName: "Perfil_Usuario_Cancelamento" },
        { uniqueName: "Data_Cancelamento" },
      ],
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      Unidade_Nome: { type: "string" },
      Requisicao_Numero: { type: "string" },
      Nome_Requisitante: { type: "string" },
      Nome_Solicitante: { type: "string" },
      Matricula_Solicitante: { type: "string" },
      Codigo_Centro_Custo: { type: "string" },
      Nome_Centro_Custo: { type: "string" },
      Conta_Centro_Custo: { type: "string" },
      Codigo_Produto: { type: "string" },
      Descricao_Produto: { type: "string" },
      Nome_Grupo: { type: "string" },
      Ca: { type: "string" },
      Categoria: { type: "string" },
      Preco_Produto: {
        type: "number",
        format: "numberFormat",
      },
      Quantidade: {
        type: "number",
        format: "numberFormat",
      },
      Descricao_Observacoes: { type: "string" },
      Data_Solicitacao: { type: "string" },
      Total: {
        type: "number",
        format: "numberFormat",
      },
      Status: { type: "string" },
      Nome_Usuario_Cancelamento: { type: "string" },
      Matricula_Usuario_Cancelamento: { type: "string" },
      Perfil_Usuario_Cancelamento: { type: "string" },
      Data_Cancelamento: { type: "string" },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const datas = ref({ from: "", to: "" });
    const statusSelecionado = ref([]);

    const statusOptions = [
      { label: "Cancelado", value: "Cancelado" },
      { label: "Rejeitado", value: "Rejeitado" },
      { label: "Cancelado Parcialmente", value: "Cancelado_Parcialmente" },
    ];

    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    const optionsFn = (date) => {
      const hoje = new Date();
      const dd = String(hoje.getDate()).padStart(2, "0");
      const mm = String(hoje.getMonth() + 1).padStart(2, "0");
      const yyyy = hoje.getFullYear();
      return date <= `${yyyy}/${mm}/${dd}`;
    };

    const formatarData = (data) => {
      if (!data || data.trim() === "") return "";
      if (data.includes("/")) return data.split("/").reverse().join("-");
      return data;
    };

    const formats = ref([
      {
        name: "",
        thousandsSeparator: "",
      },
      {
        name: "numberFormat",
        thousandsSeparator: ".",
        decimalSeparator: ",",
        decimalPlaces: -1,
      },
    ]);

    const jsonToCsvBlobUrl = (dataArray) => {
      if (!dataArray || !dataArray.length) return null;
      const headers = Object.keys(dataArray[0]);
      const escapeField = (val) => {
        const s = val == null ? "" : String(val);
        if (
          s.includes(",") ||
          s.includes('"') ||
          s.includes("\n") ||
          s.includes("\r")
        ) {
          return '"' + s.replace(/"/g, '""') + '"';
        }
        return s;
      };
      const rows = dataArray.map((row) =>
        headers.map((h) => escapeField(row[h])).join(",")
      );
      const csv = [headers.join(","), ...rows].join("\n");
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      return URL.createObjectURL(blob);
    };

    const targetColumns = [];
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const showGrandTotals = ref("");
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getResponseLink = (response) => {
      return (
        response?.data?.return?.url ||
        response?.data?.result?.url ||
        response?.data?.resultado?.dados ||
        response?.return?.url ||
        response?.result?.url ||
        response?.resultado?.dados ||
        ""
      );
    };

    const getVouchersCanceladosRejeitados = async (data, singleValue) => {
      try {
        let dataInicial = formatarData(datas.value.from);
        let dataFinal = formatarData(datas.value.to);

        if (!dataInicial) {
          const d = new Date();
          d.setDate(d.getDate() - 15);
          dataInicial = d.toISOString().split("T")[0];
        }
        if (!dataFinal) {
          dataFinal = new Date().toISOString().split("T")[0];
        }

        const filtrosBody = {
          data_inicial: dataInicial,
          data_final: dataFinal,
          vendor_id: singleValue?.id || undefined,
          status: statusSelecionado.value.length
            ? statusSelecionado.value
            : undefined,
        };

        const filtrosObject = {
          unidade: singleValue?.label,
          data_inicial: filtrosBody.data_inicial,
          data_final: filtrosBody.data_final,
          status: statusSelecionado.value.length
            ? statusSelecionado.value.join(", ")
            : "",
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "rel/getVouchersCanceladosRejeitados",
          {
            filtros: filtrosBody,
          }
        );

        const dataArray = response?.data?.data || [];
        const csvBlobUrl = jsonToCsvBlobUrl(dataArray);
        link.value = await transformCsvAndSetLink(csvBlobUrl, targetColumns);
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        console.log(error);
        loadingValue.value = false;
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        if (store.state.rel.aguardandoFiltros) {
          store.commit("rel/SET_AGUARDANDO_FILTROS", false);
          return;
        }

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = await transformCsvAndSetLink(
          getResponseLink(response),
          targetColumns
        );
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;

      link.value = await transformCsvAndSetLink(
        getResponseLink(response),
        targetColumns
      );

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getVouchersCanceladosRejeitados,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
      datas,
      statusSelecionado,
      statusOptions,
      myLocale,
      optionsFn,
      validarDataEmissao,
    };
  },
};
</script>
